export default __webpack_public_path__ + "static/media/Switch.b466d3d7.svg";